import React, {useState} from 'react';
import getTheme from './index';
import ThemeProvider from "@material-ui/styles/ThemeProvider";
import createGenerateClassName from "@material-ui/styles/createGenerateClassName";
import StylesProvider from "@material-ui/styles/StylesProvider";

const crypto = require('crypto'),
    shasum = crypto.createHash('sha1');
shasum.update('danil');

const generateClassName = createGenerateClassName({
    productionPrefix: '__' + shasum.digest('hex').substr(0, 7),
    disableGlobal: true
});

// eslint-disable-next-line no-unused-vars
export const ProjectThemeContext = React.createContext(
    {
        currentTheme: 'tealTheme',
        setTheme: null,
    },
)

const ProjectThemeProvider = (props) => {
    // eslint-disable-next-line react/prop-types
    const {children} = props

    // Read current theme from localStorage or maybe from an api
    const currentTheme = localStorage.getItem('appTheme') || 'GUSTHEME'

    // Read current theme font size from localStorage or maybe from an api
    const currentThemeFontSize = localStorage.getItem('appFontSize') || 16

    // State to hold the selected theme name
    const [themeName, _setThemeName] = useState(currentTheme)

    // State to hold the selected theme font size
    const [themeFontSize, _setThemeFontSize] = useState(currentThemeFontSize)

    // Retrieve the theme object by theme name
    const theme = getTheme(themeName)

    // Wrap _setThemeName to store new theme names in localStorage
    const setThemeName = (name) => {
        localStorage.setItem('appTheme', name)
        _setThemeName(name)
    }
    // Wrap _setThemeName to store new theme names in localStorage
    const setThemeFontSize = (fontSize) => {
        localStorage.setItem('appFontSize', fontSize)
        _setThemeFontSize(fontSize)
    }

    const contextValue = {
        currentTheme: themeName,
        currentThemeFontSize: themeFontSize,
        setTheme: setThemeName,
        setThemeFontSize: setThemeFontSize
    }

    return (
        <ProjectThemeContext.Provider value={contextValue}>
            <StylesProvider generateClassName={generateClassName} injectFirst={true}>
                <ThemeProvider theme={theme}>{children}</ThemeProvider>
            </StylesProvider>
        </ProjectThemeContext.Provider>
    )
}

export default ProjectThemeProvider
